var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient21Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 50,
    viewBox: "0 0 117 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2179_2716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5291 0C84.382 0 91.2231 6.00667 91.2231 15.1552C91.2231 21.7188 87.459 26.9565 79.8651 30.7987L72.476 34.5687C69.7392 36.0359 66.4554 38.4109 66.4554 41.414H91.2231V49.4447H57.4929V42.6701C57.4929 34.7782 63.9922 29.6132 68.5774 27.3058L76.2421 23.395C80.1407 21.4396 82.1251 18.647 82.1251 15.0861C82.1251 10.5446 79.1836 7.61426 74.5312 7.61426C69.3989 7.61426 66.4574 11.5953 66.5934 17.5302H57.4929C57.2866 6.70441 64.0609 0 74.5291 0Z",
    fill: "#00624F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.28 6.91813V0.521301H108.406V3.31691C108.405 4.7531 107.846 6.13022 106.851 7.14571C105.856 8.16119 104.507 8.73198 103.1 8.73267H97.791V16.3531H107.034C107.103 16.3531 107.17 16.3438 107.239 16.3423V49.4406H116.277V6.91555L116.28 6.91813Z",
    fill: "#00624F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1193 0C12.8031 0 15.377 1.08827 17.2748 3.0254C19.1725 4.96253 20.2387 7.58984 20.2387 10.3294V20.6587H10.1193C7.43552 20.6587 4.86163 19.5705 2.96388 17.6333C1.06614 15.6962 0 13.0689 0 10.3294H0C0 7.58984 1.06614 4.96253 2.96388 3.0254C4.86163 1.08827 7.43552 0 10.1193 0V0Z",
    fill: "#00624F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 39.6706C0 36.9311 1.06614 34.3038 2.96389 32.3667C4.86163 30.4295 7.43552 29.3413 10.1193 29.3413H20.2387V39.6706C20.2387 42.4102 19.1725 45.0375 17.2748 46.9746C15.377 48.9117 12.8031 50 10.1193 50V50C7.43552 50 4.86163 48.9117 2.96389 46.9746C1.06614 45.0375 0 42.4102 0 39.6706Z",
    fill: "#00624F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8631 50C36.1793 50 33.6054 48.9117 31.7076 46.9746C29.8099 45.0375 28.7438 42.4102 28.7438 39.6706L28.7438 29.3413L38.8631 29.3413C41.5469 29.3413 44.1208 30.4295 46.0185 32.3667C47.9163 34.3038 48.9824 36.9311 48.9824 39.6706C48.9824 42.4102 47.9163 45.0375 46.0185 46.9746C44.1208 48.9117 41.5469 50 38.8631 50Z",
    fill: "#00624F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9824 10.3294C48.9824 13.0689 47.9163 15.6962 46.0185 17.6333C44.1208 19.5705 41.5469 20.6587 38.8631 20.6587H28.7438V10.3294C28.7438 7.58985 29.8099 4.96253 31.7076 3.0254C33.6054 1.08827 36.1793 0 38.8631 0C41.5469 0 44.1208 1.08827 46.0185 3.0254C47.9163 4.96253 48.9824 7.58985 48.9824 10.3294V10.3294Z",
    fill: "#00624F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_2716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.279,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient21Logo);
export default __webpack_public_path__ + "static/media/patient-21-logo.824ae2831034983834f19b20b598957a.svg";
export { ForwardRef as ReactComponent };